module.exports = __webpack_public_path__ + "static/media/Eclectic Gallery Wall DIY Tutorial_0014.99c9e5af.jpg";